import { render } from "./BreadCrumbsWithButtons.vue?vue&type=template&id=6c90872e"
import script from "./BreadCrumbsWithButtons.vue?vue&type=script&lang=js"
export * from "./BreadCrumbsWithButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__